import * as React from 'react';

import UserName from '../../common/UserName';

import translate from '../../../../locale/translate';
import { formatDate } from '../../util/StringUtil';

interface IProps {
    hints: any[];
}

export default class HintList extends React.Component<IProps, void> {
    renderHintType(hint) {
        switch (hint.hintType) {
            case 0: {
                const children = [
                    <span key="assignee">
                        <UserName user={hint.assigned} /> {translate.gettext('is working on this issue')}
                    </span>
                ];

                if (hint.until) {
                    children.push(
                        <span key="until" className="m-l-xs">
                            {translate.gettext('until')} {formatDate(hint.until, 'LLL')}
                        </span>
                    );
                }

                return children;
            }
            case 1: {
                return <span>{translate.gettext('Issue still open')}</span>;
            }
            case 2: {
                return <span>{translate.gettext('False alarm')}</span>;
            }
            case 3: {
                return <span>{translate.gettext('Comment')}</span>;
            }
        }
    }

    renderHint(hint) {
        return (
            <div key={hint.hId} className="list-group-item small">
                <p>
                    <UserName user={hint.author} />: <span>{hint.message}</span>
                </p>
                <div className="row">
                    <div className="col-xs-8 muted">{this.renderHintType(hint)}</div>
                    <div className="col-xs-4 text-right muted">{formatDate(hint.date, 'LLL')}</div>
                </div>
            </div>
        );
    }

    render() {
        const { hints } = this.props;

        return (
            <ul className="list-group">
                {hints.map(this.renderHint.bind(this))}
            </ul>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/alerts/listAlerts/HintList.tsx